import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Observable } from "rxjs/Observable";
import { from } from "rxjs/observable/from";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  ComboService,
  CommonService,
  SampleService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";
import * as commonActions from "../../../store/actions/common.actions";
import { SamplePrint } from "./samplePrint";
import * as $ from "jquery";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sampleInward.html",
})
export class sampleInward implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  matchList: any;
  data: any;
  sampleList: any;
  shadelist = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  styleData: any;
  partyList: Observable<any[]>;
  fabricList: any[];
  verifier: string;
  reason: string;
  si_id : any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "sd.samp_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("stickerTemplate") stickerTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  sampleCancelReasonList = [];
  typeList = ["SWATCH", "SAMPLE", "SWATCH & SAMPLE"];
  styleList = ["FORMAL", "CASUAL", "STYLISH FORMAL", "CLUB WEAR"];
  brandList = ["EXPOSE", "ARAZA", "GREEN OLIVE", "LEO BOYS", "JOB"];
  samplePrefixList = [
    {
      style : "FORMAL",
      prefix : "FL-"
    },
    {
      style : "CASUAL",
      prefix : "CL-"
    },
    {
      style : "STYLISH FORMAL",
      prefix : "SF-"
    },
    {
      style : "CLUB WEAR",
      prefix : "CW-"
    }
  ];
  filterExpand = false;
  filterData: any = {
    sample_no: "",
    fab_design_no: "",
  };
  sampledata = {
    sample_no: "",
    fab_design_no: "",
    tot_colors: "",
    brand: "EXPOSE",
    style: "",
    dc_no: "",
    season: "",
    mtrs: 0,
    type: "",
    sample_prefix : ''
  };
  filter = {
    sample_no: "",
    fab_design_no: "",
    tot_colors: "",
    brand: "",
    style: "",
    dc_no: "",
    season: "",
  };
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;
  seasonList = [];
  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private sampService: SampleService,
    public datePipe: DatePipe,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private comboservice: ComboService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getSampleList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    $("#entry_div").hide();
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Season",
        prop: "season",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Samp.no",
        prop: "sample_no",
        height: 20,
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        headerClass: "text-center",
        cellClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Fabric Design",
        prop: "fab_design_no",
        height: 20,
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
      },
      {
        name: "Style",
        prop: "style",
        height: 20,
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Tot.Clr",
        prop: "tot_colors",
        height: 20,
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Brand",
        prop: "brand",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        cellClass: "text-center",
        align: "right",
        headerClass: "text-center",
        type: "text",
      },
      // { name: 'Style', prop: 'style', height: 20, minWidth: 100, maxWidth: 100, width: 100, headerClass: 'text-center', sortable: false },
      {
        name: "DC No",
        prop: "dc_no",
        height: 20,
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Mtrs",
        prop: "mtrs",
        height: 20,
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Type",
        prop: "type",
        height: 20,
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Action",
        prop: "action",
        height: 20,
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.data = this.commonService.itemMaster();
    //   this.getFabDesigns();
    this.getSeasonList();
    this.getCancelReasonList();
    this.pageCallback({ offset: 0 });
    //   this.sampledata.season = this.invoiceData[0].season;
  }

  getFabDesigns() {
    let params;
    let that = this;
    this.sampService.getFabDesigns(params).then(function (res: any) {
      that.fabricList = res.data;
      that.sampledata.season = res.lastSeason.season;
    });
  }
  getLastSeason() {
    let params;
    let that = this;
    this.sampService.getLastSeason(params).then(function (res: any) {
      that.sampledata.season = res.data;
    });
  }
  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        //          this.addEditInvoice('Add', '');
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSampleList();
  }
  onSelectStyle(style){

    let index = this.samplePrefixList.findIndex(el => el.style == style);
    this.sampledata.sample_prefix = this.samplePrefixList[index].prefix;
    
  }
  addSample() {
    let temp = this.sampledata;
    let canSave = false;

    if(this.sampledata.brand == 'JOB'){
      if (
        !temp.fab_design_no ||
        !temp.sample_no ||
        !temp.season ||
        !temp.tot_colors ||
        !this.sampledata.type ||
        !temp.brand
      ) {
        canSave = true;
      }
    }else{
      if (
        !temp.fab_design_no ||
        !temp.sample_no ||
        !temp.season ||
        !temp.tot_colors ||
        !this.sampledata.mtrs ||
        !this.sampledata.type ||
        !temp.dc_no ||
        !temp.brand
      ) {
        canSave = true;
      }
    }



    if (canSave) {
      swal("Make sure that all the entries are given!");
      return false;
    }
    let that = this;
    swal({
      title: "Are you sure to save this Sample?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.sampledata.sample_no = that.sampledata.sample_prefix+that.sampledata.sample_no;
      let params = that.sampledata;
      // that.isLoading = true;
      that.sampService.addSampleInward(params).then(function (res: any) {
        if (res == false) {
          swal("Please Enter Dc First");
        } else {
          that.getSampleList();
          // that.sampledata = {
          //     sample_no: '',
          //     fab_design_no: '',
          //     tot_colors: '',
          //     brand: '',
          //     style: '',
          //     dc_no: '',
          //     season: ''
          // }
          that.sampledata.sample_no = "";
          that.sampledata.fab_design_no = "";
          that.sampledata.tot_colors = "";
          that.sampledata.brand = "";
          that.sampledata.style = "";
          that.sampledata.dc_no = "";
          that.sampledata.mtrs = 0;
          that.sampledata.type = "";
          that.sampledata.sample_prefix = "";
          //      that.sampledata.season = that.invoiceData[0].season;
        }
      });
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];
      for (let i = res.length - 1; i > res.length - 11; i--) {
        partialSeason.push(res[i]);
      }

      this.seasonList = partialSeason;
    });
  }
  getCancelReasonList(){
    let params = {};
    this.sampService.getCancelReasonList(params).then((res: any) => {
     
      this.sampleCancelReasonList = res.data;
    });
  }
  showFilter() {
    $("#entry_div").hide(1000);
    $("#filter_div").show(1000);
  }
  showEntry() {
  

    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
  }
  editSampleInward(row) {
    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
    this.sampledata = row;
  }
  onEnterKeyPressed(nextEl: string) {
    setTimeout(() => {
      $("#" + nextEl).focus();
    }, 100);
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSampleList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSampleList();
  }

  getSampleList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.sampService
      .sampleInwardList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;
      });
  }
  fabricValList(dc_no, fab_no) {
    if(this.sampledata.brand != 'JOB'){
      let data = {
        dc_no: dc_no,
        fabric_no: fab_no,
      };
      let that = this;
      this.isLoadMask = this.sampService
        .fabricValList(data)
        .then(function (res: any) {
          that.loadingIndicator = false;
          if (res == false) {
            swal("This Fabric number is not in this Dc");
          }
        });
    }
    
  }
  openModalCancel(row){
    this.si_id = row.si_id;
    $("#modalCart").modal("show");
    setTimeout(() => {
      $("#verifier").focus();
    },200);
  }
  cancelSample() {
    let that = this;
    swal({
      title: "Are you sure to Cancel this Sample?",
      text: "You will not be able to recover this Sample",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {

          let params = {
            si_id: that.si_id,
            verifier: that.verifier,
            reason: that.reason
          };
          that.sampService.cancelSample(params).then((res: any) => {
            if(res.success){
              swal("Sample cancelled");
              that.getSampleList();
            }
         
          });
         
    }).catch(() => {
      return;
    });
  }

  clearFilter(): void {
    this.filter = {
      sample_no: "",
      fab_design_no: "",
      tot_colors: "",
      brand: "",
      style: "",
      dc_no: "",
      season: "",
    };
    this.applyFilter();
  }
  clear() {
    //  this.sampledata.sample_no='';
    // this.sampledata.fab_design_no ='';
    // this.sampledata.tot_colors ='';
    // this.sampledata.brand ='';
    // this.sampledata.style ='';
    // this.sampledata.dc_no ='';
    this.sampledata = {
      sample_no: "",
      fab_design_no: "",
      tot_colors: "",
      brand: "",
      style: "",
      dc_no: "",
      mtrs: 0,
      type: "",
      season: this.sampledata.season,
      sample_prefix : ''
    };
  }
  applyFilter(): void {
    this.getSampleList();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  addEditInvoice(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSampleList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "ADD SAMPLE",
          id: "AddEditSample",
          name: "ADD SAMPLE",
          mode: mode,
          data: row,
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "EDIT CREATE SAMPLE",
          id: "AddEditcreateSample",
          name: "EDIT CREATE SAMPLE",
          mode: mode,
          data: row,
        },
      };
    }
    else if (mode == "addSample") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "ADD CREATE SAMPLE",
          id: "AddEditcreateSample",
          name: "ADD CREATE SAMPLE",
          mode: mode,
          data: row,
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "SAMPLE",
          tabName: "VIEW SAMPLE",
          id: "AddEdit",
          name: "VIEW SAMPLE",
          mode: mode,
          data: row,
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  deleteInvoice(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Sample?",
      text: "You will not be able to recover this Sample",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.sampService
          .deleteSample(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getSampleList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  getStyleDetails(row) {
    let params = {
      style_no: row.style_no,
    };
    this.sampService.getStyleDetails(params).then((res: any) => {
      this.styleData = res.data;
      this.printSample("Print", row);
      //  this.loadeditsamplelist(row);
    });
  }

  bsModalRef: BsModalRef;
  printSample(mode: string, row: any): void {
    let that = this;
    setTimeout(function () {
      that.filterPanel.close();
    }, 10);

    this.bsModalRef = this.modalService.show(SamplePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.title = mode + this.title + "Details";
    this.bsModalRef.content.mode = mode;
    this.bsModalRef.content.sampledata = Object.assign({}, row);
    this.bsModalRef.content.styledata = Object.assign({}, this.styleData);
    // this.bsModalRef.content.matchlist = this.matchList;
    (this.bsModalRef.content.tabID = this.tabID),
      (this.bsModalRef.content.tabTitle = this.title),
      this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
        if (this.title == "DesignStockComponent")
          this.store.dispatch(new commonActions.LoadAllParty());
        else this.store.dispatch(new commonActions.LoadAllCompany());
      });
  }

  loadeditsamplelist(row) {
    let params = {
      samp_id: row.samp_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      this.shadeList(row);

      this.sampleList = res.data;
    });
  }
  shadeList(row) {
    // let coloList = row.sample_color;
    let sample_no = row.sample_no;
    let params = {
      sample_no: sample_no,
    };

    this.sampService.getShadeList(params).then((res: any) => {
      let data1: any = res.data;

      for (var i = 0; i < data1.length; i++) {
        for (var key in data1[i]) {
          let temp = data1[i][key];
          this.shadelist.push(temp);
        }
      }
      this.clickPrint(row, this.shadelist);
      console.log(res);
    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.sampService
      .sampleSticker(params)
      .then(function (res: any) {});
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/sampleInward.ts